import ThreeDSecure from './ThreeDSecure';

export default ThreeDSecure;
